import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'birchBark',
      d: 'M-0.5,-2h0.5v0.5h-0.5zM-0.5,-1.5h1v1.5h-1zM0,0h0.5v0.5h-0.5zM-0.5,0.5h0.5v0.5h-0.5zM-0.5,1h1v0.5h-1zM-0.5,1.5h0.5v1h-0.5zM-0.5,2.5h1v0.5h-1z',
    },
    {
      paint: [
        ['birchBark', 0.65],
        ['trunk', 0.35],
      ],
      d: 'M-0.5,0h0.5v0.5h-0.5zM0,0.5h0.5v0.5h-0.5zM0,1.5h0.5v1h-0.5zM-1,2.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'birchYellow',
      d: 'M-1,-6h1v0.5h-1zM-1.5,-5.5h3v0.5h-3zM-1,-5h1.5v0.5h-1.5zM1.5,-5h0.5v0.5h-0.5zM-2.5,-4.5h5v0.5h-5zM-3,-4h5.5v0.5h-5.5zM-2.5,-3.5h5v0.5h-5zM-2.5,-3h3v0.5h-3zM1.5,-3h0.5v0.5h-0.5zM-2,-2.5h3v0.5h-3zM-1.5,-2h1v0.5h-1zM0.5,-2h1v0.5h-1z',
    },
    {
      paint: [
        ['birchYellow', 0.68],
        ['parasolStripe', 0.32],
      ],
      d: 'M-2,-5.5h0.5v0.5h-0.5zM-3,-5h2v0.5h-2zM0.5,-5h1v0.5h-1zM-3,-4.5h0.5v0.5h-0.5zM0,-2h0.5v0.5h-0.5z',
    },
    { paint: 'autumnGold', d: 'M0.5,-3h1v0.5h-1zM1,-2.5h1v0.5h-1z' },
  ],
  pixels: 93,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'birchBark',
      d: 'M-0.5,-2h1v2h-1zM0,0h0.5v0.5h-0.5zM-0.5,0.5h0.5v0.5h-0.5zM-0.5,1h1v0.5h-1zM-0.5,1.5h0.5v1h-0.5zM-0.5,2.5h1v0.5h-1z',
    },
    {
      paint: [
        ['birchBark', 0.65],
        ['trunk', 0.35],
      ],
      d: 'M-0.5,0h0.5v0.5h-0.5zM0,0.5h0.5v0.5h-0.5zM0,1.5h0.5v1h-0.5zM-1,2.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['birchYellow', 0.7],
        ['parasolStripe', 0.3],
      ],
      d: 'M-0.5,-6h0.5v0.5h-0.5zM-1.5,-5.5h2v0.5h-2zM1,-5.5h0.5v0.5h-0.5zM-1,-5h1.5v0.5h-1.5zM1.5,-5h0.5v0.5h-0.5zM-3,-4.5h5.5v0.5h-5.5zM-2.5,-4h5v0.5h-5zM-2.5,-3.5h4.5v0.5h-4.5zM-2.5,-3h3v0.5h-3zM1.5,-3h0.5v0.5h-0.5zM-1.5,-2.5h1v0.5h-1zM0.5,-2.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['birchYellow', 0.48],
        ['parasolStripe', 0.53],
      ],
      d: 'M-2,-5.5h0.5v0.5h-0.5zM0.5,-5.5h0.5v0.5h-0.5zM-3,-5h2v0.5h-2zM0.5,-5h1v0.5h-1zM-0.5,-2.5h1v0.5h-1z',
    },
    { paint: 'autumnGold', d: 'M0.5,-3h1v0.5h-1zM1,-2.5h1v0.5h-1z' },
  ],
  pixels: 85,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'birchBark',
      d: 'M-0.5,-5.5h0.5v1.5h-0.5zM-0.5,-4h2v0.5h-2zM-1.5,-3.5h2.5v0.5h-2.5zM-1,-3h1.5v0.5h-1.5zM-0.5,-2.5h1v2.5h-1zM0,0h0.5v0.5h-0.5zM-0.5,0.5h0.5v0.5h-0.5zM-0.5,1h1v0.5h-1zM-0.5,1.5h0.5v1h-0.5zM-0.5,2.5h1v0.5h-1z',
    },
    {
      paint: [
        ['birchBark', 0.65],
        ['trunk', 0.35],
      ],
      d: 'M-0.5,0h0.5v0.5h-0.5zM0,0.5h0.5v0.5h-0.5zM0,1.5h0.5v1h-0.5zM-1,2.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'birchYellow',
      d: 'M-2.5,-5.5h0.5v0.5h-0.5zM0.5,-5.5h1.5v0.5h-1.5zM-3,-5h0.5v0.5h-0.5zM0,-5h0.5v0.5h-0.5zM1.5,-5h0.5v0.5h-0.5zM-3,-4.5h2v0.5h-2zM0.5,-4.5h1v0.5h-1zM-3,-4h1.5v0.5h-1.5zM-2.5,-3.5h0.5v0.5h-0.5zM-2,2h1v0.5h-1z',
    },
    {
      paint: [
        ['birchYellow', 0.68],
        ['parasolStripe', 0.32],
      ],
      d: 'M-2,-5.5h1v0.5h-1zM0,-5.5h0.5v0.5h-0.5zM-2.5,-5h1.5v0.5h-1.5zM0.5,-5h1v0.5h-1zM0,-4.5h0.5v0.5h-0.5zM1.5,-4.5h0.5v0.5h-0.5zM-1.5,-4h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['birchYellow', 0.7],
        ['trunk', 0.3],
      ],
      d: 'M-2,2.5h1v0.5h-1z',
    },
  ],
  pixels: 70,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
